import React from 'react';
import { Message } from '../../types';

interface MessageBubbleProps {
  message: Message;
}

const MessageBubble: React.FC<MessageBubbleProps> = ({ message }) => {
  const isOutbound = message.direction === 'outbound';
  const timestamp = new Date(message.created_at).toLocaleTimeString('en-US', {
    hour: 'numeric',
    minute: '2-digit',
    hour12: true,
  });

  const getStatusIcon = (status: Message['status']): string => {
    const icons: Record<Message['status'], string> = {
      queued: '⏳',
      sending: '📤',
      sent: '✓',
      delivered: '✓✓',
      received: '📩',
      failed: '❌',
      undelivered: '⚠️',
      read: '👁️',
    };
    return icons[status] || '❓';
  };

  return (
    <div className={`message-bubble ${isOutbound ? 'message-bubble--outbound' : 'message-bubble--inbound'}`}>
      <div className="message-bubble__container">
        <div className="message-bubble__header">
          <span className="message-bubble__phone">
            {isOutbound ? `To: ${message.to_phone}` : `From: ${message.from_phone}`}
          </span>
          <span className="message-bubble__direction">
            {isOutbound ? '↑' : '↓'}
          </span>
        </div>
        
        <div className="message-bubble__content">
          <p className="message-bubble__text">{message.body}</p>
          
          {message.media_urls && message.media_urls.length > 0 && (
            <div className="message-bubble__media">
              {message.media_urls.map((url, index) => (
                <a 
                  key={index}
                  href={url} 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="media-link"
                >
                  📎 Media attachment {index + 1}
                </a>
              ))}
            </div>
          )}
        </div>

        <div className="message-bubble__footer">
          <span className="message-bubble__timestamp">{timestamp}</span>
          <div className="message-bubble__status">
            <span className="status-icon">{getStatusIcon(message.status)}</span>
            <span className="status-text">{message.status}</span>
          </div>
        </div>

        {message.sid && (
          <div className="message-bubble__sid" title="Twilio Message SID">
            SID: {message.sid.substring(0, 8)}...
          </div>
        )}
      </div>
    </div>
  );
};

export default MessageBubble;